import React from "react";
import { motion } from "framer-motion";
import { fadeIn, staggerContainer } from "../variants";
import { eventsData } from "../data";
import { MapPin, Calendar } from "lucide-react";

const Events = () => {
  return (
    <section id="events" className="section scroll-mt-20">
      <div className="container mx-auto">

        {/* Section header */}
        <motion.div
          variants={staggerContainer(0.12, 0.1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="section-header"
        >
          <motion.p variants={fadeIn("up")} className="eyebrow mb-4">
            Mobilisation et engagement
          </motion.p>
          <motion.h2 variants={fadeIn("up", 0.05)} className="h2 mb-6">
            Nos activités et événements
          </motion.h2>
          <motion.p variants={fadeIn("up", 0.1)} className="lead">
            Courses solidaires, soirées de gala, assemblées — nos membres mobilisent
            chaque année la communauté pour soutenir les enfants de Sarh.
          </motion.p>
        </motion.div>

        {/* Timeline */}
        <div className="relative max-w-3xl mx-auto">
          {/* Vertical line */}
          <div className="absolute left-6 lg:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-secondary to-accent transform lg:-translate-x-0.5" />

          <div className="space-y-10">
            {eventsData.map((event, i) => {
              const isEven = i % 2 === 0;
              return (
                <motion.div
                  key={i}
                  variants={fadeIn(isEven ? "right" : "left", i * 0.1)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.2 }}
                  className={`relative flex items-start gap-6 lg:gap-0 ${
                    isEven ? "lg:flex-row" : "lg:flex-row-reverse"
                  }`}
                >
                  {/* Mobile / tablet dot */}
                  <div className="relative z-10 flex-shrink-0 w-12 h-12 rounded-full bg-white border-2 border-primary shadow-md flex items-center justify-center lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:top-4">
                    <span className="text-primary font-display font-bold text-xs text-center leading-tight">
                      {event.date.split(" ")[0]}
                    </span>
                  </div>

                  {/* Content card */}
                  <div className={`flex-1 lg:w-[calc(50%-3rem)] lg:max-w-[calc(50%-3rem)] ${isEven ? "lg:pr-10 lg:ml-0" : "lg:pl-10 lg:ml-auto lg:mr-0"}`}>
                    <div className="card p-6 hover:shadow-card-hover transition-shadow duration-300">
                      {/* Date badge */}
                      <div className="inline-flex items-center gap-1.5 text-secondary font-display font-semibold text-xs uppercase tracking-widest mb-3">
                        <Calendar size={12} />
                        {event.date}
                      </div>
                      <h3 className="font-heading font-bold text-lg text-dark mb-2">
                        {event.title}
                      </h3>
                      <div className="flex items-center gap-1.5 text-grey text-xs mb-3">
                        <MapPin size={12} />
                        {event.location}
                      </div>
                      <p className="text-grey text-sm leading-relaxed">
                        {event.description}
                      </p>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>

        {/* CTA bottom */}
        <motion.div
          variants={fadeIn("up")}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.4 }}
          className="text-center mt-16 p-8 bg-primary/5 rounded-2xl border border-primary/10"
        >
          <p className="text-grey mb-2">Vous souhaitez organiser un événement solidaire ?</p>
          <a href="#contact" className="link font-semibold text-primary">
            Contactez-nous — nous vous accompagnons
          </a>
        </motion.div>

      </div>
    </section>
  );
};

export default Events;
